const translationKeys = {
  form_validation_type_mismatch: 'form_validation_type_mismatch',
  form_validation_account_number_required:
    'form_validation_account_number_required',
  form_validation_account_number_invalid:
    'form_validation_account_number_invalid',
  form_validation_date_invalid: 'form_validation_date_invalid',
  form_validation_date_required: 'form_validation_date_required',
  form_validation_number_required: 'form_validation_number_required',
  form_validation_number_min_value: 'form_validation_number_min_value',
  form_validation_number_max_value: 'form_validation_number_max_value',
  form_validation_string_required: 'form_validation_string_required',
  form_validation_string_min_length: 'form_validation_string_min_length',
  form_validation_string_max_length: 'form_validation_string_max_length',
  form_validation_cid_required: 'form_validation_cid_required',
  form_validation_cid_invalid: 'form_validation_cid_invalid',
  form_validation_boolean_required: 'form_validation_boolean_required',
  form_validation_boolean_invalid: 'form_validation_boolean_invalid',
  form_validation_boolean_be_true: 'form_validation_boolean_be_true',
  form_validation_boolean_be_false: 'form_validation_boolean_be_false',
  form_validation_ssn_invalid: 'form_validation_ssn_invalid',
  form_validation_ssn_required: 'form_validation_ssn_required',
  form_validation_email_required: 'form_validation_email_required',
  form_validation_email_invalid: 'form_validation_email_invalid',
  form_validation_mobile_number_invalid:
    'form_validation_mobile_number_invalid',
  form_validation_mobile_number_required:
    'form_validation_mobile_number_required',
  form_validation_email_max_length: 'form_validation_email_max_length',
};

Object.freeze(translationKeys);

export default translationKeys;
